import styled from '@pinecast/styles';
import * as React from 'react';

import {ErrorFlag} from './icons';

const ErrorWrap = styled('div', {
  alignItems: 'center',
  color: '#d24242',
  display: 'flex',
  padding: '4px 0',
});

const InlineError = ({error}: {error: React.ReactNode}) => (
  <ErrorWrap>
    <ErrorFlag color="#d24242" size={16} style={{marginRight: 4}} />
    {error}
  </ErrorWrap>
);

export default InlineError;
